<div
  #scrollable
  class="scrollableContent flex flex-col gap-4 px-1 py-4 h-full overflow-y-auto"
>
  <div
    *ngFor="let message of messages$().history"
    #msgHistory
    class="flex gap-2 items-stretch"
  >
    <flx-ai-chat-bubble
      [message]="message"
      [loading]="loading()"
      (sendFeedback)="sendFeedback(message, $event)"
      class="w-full"
    />
  </div>

  <div
    *ngIf="messages$().updating as updatingMsg"
    class="flex gap-2 items-stretch"
  >
    <flx-ai-chat-bubble
      [message]="updatingMsg"
      [loading]="loading()"
      (sendFeedback)="sendFeedback(updatingMsg, $event)"
      class="w-full"
    />
  </div>

  @if (showAiActionButtons() && !isLastMsgError()) {
    <div class="flex items-center ml-8 gap-2">
      @for (action of aiDraftActions; track action) {
        <flx-ai-action-button
          [label]="action.label"
          [flavor]="action.flavor"
          [iconName]="action.icon"
          [disabled]="action.disabled"
          (clicked)="action.onAction()"
        />
      }
    </div>
  }
  @if (showAuditActionButtons()) {
    <div class="flex items-center ml-8 gap-2">
      @for (action of aiAuditActions; track action) {
        <flx-ai-action-button
          [label]="action.label"
          [flavor]="action.flavor"
          [iconName]="action.icon"
          [disabled]="action.disabled"
          (clicked)="action.onAction()"
        />
      }
    </div>
  }

  @if (showPendingMessage()) {
    <div class="p-2 text-lg text-white rounded-xl bg-neutral-700">
      <flx-ai-pending-message
        [status]="sessionPendingRequestStatus()"
        [message]="pendingRequestStaticMessage()"
        (cancelPendingRequest)="cancelPendingRequest()"
      />
    </div>
  }
</div>
